<template>
  <div>
    <PhysicianProfileView></PhysicianProfileView>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const PhysicianProfileView = defineAsyncComponent(() =>
  import("@/components/physicians/PhysicianProfileView")
);
export default {
  components: {
    PhysicianProfileView,
  },
};
</script>
